import { createApp, defineAsyncComponent } from 'vue';
import mitt from 'mitt';
import axios from 'axios';

window.axios = axios;
window.mitt = mitt;
window.bus = mitt();

if (typeof window !== 'undefined') {
  window.isMobile = function () {
    return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent) || window.innerWidth <= 768;
  };
}

import { Icon } from '@iconify/vue';
import registry from '@/componentRegistry';
import intersect from '@/direct/intersect.js';
import { FitText, initFitText } from './directives/fit-text';

import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import 'swiper/css/effect-fade';
import 'swiper/css/effect-cards';

import Swiper from 'swiper';
import { Pagination } from 'swiper/modules';
import { EffectCards } from 'swiper/modules';
window.Swiper = Swiper;
window.SwiperModules = { Pagination: Pagination, EffectCards: EffectCards };

const numflipDirective = {
  mounted(el, binding) {
    el.value = formatData(binding.value);
  },
  updated(el, binding) {
    var numberAnimation = function (el, oldValue, newValue) {
      var start = null, duration = 200;
      function step(timestamp) {
        if (!start) start = timestamp;
        var progress = timestamp - start;
        el.value = formatData(Math.round(oldValue + (newValue - oldValue) * progress / duration));
        if (progress < duration) {
          window.requestAnimationFrame(step);
        } else {
          el.value = formatData(newValue);
        }
      }
      el.value = formatData(oldValue);
      window.requestAnimationFrame(step);
    };

    let value_input = parseFloat(el.value.replace(/[^\.\d]/g, ''));
    if ((parseFloat(binding.value) != value_input || parseFloat(binding.value) != parseFloat(binding.oldValue)) && binding.value !== false) {
      numberAnimation(el, binding.oldValue, binding.value);
    }
  }
};

function formatData(number) {
  let floatNum = parseFloat(number);
  if (floatNum < 1000) {
    return String(floatNum);
  } else {
    return floatNum.toLocaleString('ru');
  }
}

if (typeof window.global_vue !== 'undefined') {
  window.global_vue.forEach(function (item, index, array) {
    const components = {};

    if (item.components) {
      item.components.forEach(name => {
        if (registry[name]) {
          components[name] = defineAsyncComponent(registry[name]);
        }
      });
    }

    const itemData = item.data;
    const dataFn = (typeof itemData === 'function')
      ? itemData
      : function () { return itemData; };

    const appOptions = {
      ...item,
      data: dataFn,
      components,
      mixins: [],
    };

    let app = createApp(appOptions);

    app.config.globalProperties.$isMobile = function () {
      if (typeof window === 'undefined' || typeof navigator === 'undefined') return false;
      return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent) || window.innerWidth <= 768;
    };

    app.config.compilerOptions = { isCustomElement: (tag) => tag.startsWith('swiper-') };
    app.directive('numflip', numflipDirective);
    app.directive('intersect', intersect);
    app.directive('fit-text', FitText);
    app.component('Icon', Icon);

    app.config.errorHandler = (err, instance, info) => {
      console.error('Vue Error:', err);
    };

    if (item.el) {
      app.mount(item.el);
    } else {
      console.error('Не указан "el" для компонента');
    }
  });

  window.global_vue = [];
}

window.initVueForm = function(config) {
  if (!config || !config.el) {
    console.error('initVueForm: config or config.el is missing');
    return;
  }

  const components = {};
  if (config.components) {
    config.components.forEach(name => {
      if (registry[name]) {
        components[name] = defineAsyncComponent(registry[name]);
      }
    });
  }

  const itemData = config.data;
  const dataFn = (typeof itemData === 'function')
    ? itemData
    : function () { return itemData; };

  const appOptions = {
    ...config,
    data: dataFn,
    components,
    mixins: [],
  };

  let app = createApp(appOptions);
  app.config.globalProperties.$isMobile = function () {
    if (typeof window === 'undefined' || typeof navigator === 'undefined') return false;
    return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent) || window.innerWidth <= 768;
  };
  app.config.compilerOptions = { isCustomElement: (tag) => tag.startsWith('swiper-') };
  app.directive('numflip', numflipDirective);
  app.directive('intersect', intersect);
  app.directive('fit-text', FitText);
  app.component('Icon', Icon);

  app.config.errorHandler = (err, instance, info) => {
    console.error('Vue Error:', err);
  };

  app.mount(config.el);
};

// Initialize fit-text on standalone elements outside Vue apps
if (typeof document !== 'undefined') {
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initFitText);
  } else {
    initFitText();
  }
}
